<ng-container *ngIf="mode === 'register'; else login">
  <!-- show login link if not connected -->
  <p class="other-links"><span i18n="@@auth.signup.alreadyAnAccount">Already an account ?</span>&nbsp;<a [routerLink]="['', { outlets: { auth: ['authentification', 'login'] }}]" i18n="@@auth.signup.signin">Login</a></p>
  <!-- social provider for not connected -->
  <div class="kz-loginV2-vendors--abs">
    <div class="kz-loginV2-container-quickly">
      <div class="kz-loginV2-subTitle" i18n="@@auth.signup.social.register-quickly">Register QUICKLY</div>
      <p i18n="@@auth.signup.social.connect.description">with your google account, create your account easily in 2 clicks </p>
      <button class="kz-vendors kz-vendors--google" i18n="@@auth.signup.social.register-google" appGtmTrack="{{ gtm + 'google' }}" (click)="loginWithProvider('google')">Register with Google</button>
    </div>
    <div class="kz-loginV2-or" i18n="@@auth.signup.social.other">or</div>
    <div class="kz-loginV2-vendors" [ngClass]="{'kz-loginV2-vendors--inline': inline, 'kz-loginV2-vendors--left': align == 'left', 'kz-loginV2-vendors--right': align == 'right', 'kz-loginV2-vendors--center': align == 'center'}">
      <button class="kz-vendors kz-vendors--apple" appGtmTrack="{{ gtm + 'apple' }}" (click)="loginWithProvider('apple')">Apple</button>
    </div>
  </div>
</ng-container>

<ng-template #login>
  <div class="kz-loginV2-vendors" [ngClass]="{'kz-loginV2-vendors--inline': inline, 'kz-loginV2-vendors--left': align == 'left', 'kz-loginV2-vendors--right': align == 'right', 'kz-loginV2-vendors--center': align == 'center'}">
    <button class="kz-vendors kz-vendors--google" appGtmTrack="{{ gtm + 'google' }}" (click)="loginWithProvider('google')">Google</button>
    <button class="kz-vendors kz-vendors--apple" appGtmTrack="{{ gtm + 'apple' }}" (click)="loginWithProvider('apple')">Apple</button>
  </div>
</ng-template>
